import { useGetIvaQuery } from "../store/services/LookUpService";

export default function CategorieIvaLookUp() {
    const {data} = useGetIvaQuery('');
    let optionCatIva = data?.map((categoria: any) => ({value: categoria?.id, label: categoria?.nome}))
    return optionCatIva;
}